import banner, { alertVariants, AlertVariantsType as IAlertVariantsType } from './banner';
import button from './button';

const alert = {
  banner,
  button,
};

export type AlertVariantsType = IAlertVariantsType;

export { alertVariants };
export default alert;
